import { render, staticRenderFns } from "./SettingsLicense.vue?vue&type=template&id=4431900f"
import script from "./SettingsLicense.vue?vue&type=script&lang=js"
export * from "./SettingsLicense.vue?vue&type=script&lang=js"
import style0 from "./SettingsLicense.vue?vue&type=style&index=0&id=4431900f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports